class ShopBrowsePreview extends HTMLElement {
  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initialize(), {once:true});
    } else this.initialize();
  }
  initialize() {
    if (this.initialized) return;
    this.cards = [...this.querySelectorAll('[data-shop-card]')];
    this.form = this.querySelector('[data-shop-form]');
    this.category = '';
    if (!this.form || !this.cards.length) return;
    this.initialized = true;
    this.names = ['shop_q','shop_brand','shop_min','shop_max','shop_sort','shop_style','shop_sanitizing','shop_phase','shop_voltage','shop_width','shop_depth','shop_height','shop_cabinet','shop_doors','shop_door_type','shop_compressor','shop_coffee_application','shop_coffee_drink','shop_coffee_water','shop_coffee_daily'];
    this.cards.forEach((card,i) => {
      card.dataset.shopOrder = String(i);
      try { card.shopCoffeeDrinks = JSON.parse(card.dataset.shopCoffeeDrinks || '[]') || []; } catch { card.shopCoffeeDrinks = []; }
      try { card.shopConfigs = JSON.parse(card.dataset.shopConfigs || '[]'); } catch { card.shopConfigs = []; }
      if (!card.shopConfigs.length) card.shopConfigs = [{price:Number(card.dataset.shopPrice),phase:'',voltage:[]}];
      card.shopConfigs.forEach(config => {
        config.phase = String(config.phase || '');
        config.voltage = (Array.isArray(config.voltage) ? config.voltage : []).map(v => String(v).replace(/\s*V$/i,'').trim());
      });
    });
    this.list = this.cards[0].parentElement;
    this.querySelectorAll('button[data-shop-category]').forEach(button => button.addEventListener('click', () => {
      this.category = button.dataset.shopCategory;
      this.populate();
      this.apply();
    }));
    this.form.addEventListener('submit', e => e.preventDefault());
    this.form.addEventListener('input', () => this.apply());
    this.form.addEventListener('change', () => this.apply());
    this.querySelector('[data-shop-reset]').addEventListener('click', () => {
      this.form.reset(); this.category = ''; this.populate(); this.apply();
    });
    this.onPopState = () => { this.readURL(); this.apply(false); };
    window.addEventListener('popstate', this.onPopState);
    this.readURL(); this.apply(false);
  }
  disconnectedCallback() { window.removeEventListener('popstate',this.onPopState); }
  matchesCategory(card,category) {
    if (category === 'discount-equipment') return card.dataset.shopDiscount === 'true';
    if (card.dataset.shopDiscount === 'true') return false;
    return !category || card.dataset.shopCategory === category;
  }
  familyOf(card) {
    if (card.dataset.shopFamily) return card.dataset.shopFamily;
    if (['refrigerators','freezers'].includes(card.dataset.shopCategory)) return 'refrigeration';
    if (['dishwashers','glasswashers'].includes(card.dataset.shopCategory)) return 'warewashing';
    return 'supplies';
  }
  populate() {
    const f = this.form.elements;
    const scope = this.cards.filter(c => this.matchesCategory(c,this.category));
    const query = f.shop_q.value.trim().toLowerCase();
    const brand = f.shop_brand.value;
    const min = f.shop_min.value === '' ? 0 : Number(f.shop_min.value)*100;
    const max = f.shop_max.value === '' ? Infinity : Number(f.shop_max.value)*100;
    const searched = scope.filter(c => !query || c.dataset.shopTitle.toLowerCase().includes(query));
    const narrowed = searched.filter(c => (!brand || c.dataset.shopBrand === brand) && c.shopConfigs.some(v => Number(v.price) >= min && Number(v.price) <= max));
    const families = [...new Set(narrowed.map(c => this.familyOf(c)))];
    let family = families.length === 1 ? families[0] : '';
    if (['refrigerators','freezers'].includes(this.category)) family = 'refrigeration';
    if (['dishwashers','glasswashers'].includes(this.category)) family = 'warewashing';
    const equipment = ['refrigeration','warewashing','coffee'].includes(family);
    const context = narrowed.length ? narrowed : scope;
    const specs = {
      shop_brand:{values:c=>[c.dataset.shopBrand], allowed:true},
      shop_coffee_application:{values:c=>[c.dataset.shopCoffeeApplication], allowed:family==='coffee'},
      shop_coffee_drink:{values:c=>c.shopCoffeeDrinks, allowed:family==='coffee'},
      shop_coffee_water:{values:c=>[c.dataset.shopCoffeeWater], allowed:family==='coffee'},
      shop_coffee_daily:{values:c=>[c.dataset.shopCoffeeDaily], allowed:family==='coffee'},
      shop_style:{values:c=>[c.dataset.shopStyle], allowed:family==='warewashing'},
      shop_sanitizing:{values:c=>[c.dataset.shopSanitizing], allowed:family==='warewashing'},
      shop_phase:{values:c=>c.shopConfigs.map(v=>v.phase), allowed:equipment},
      shop_voltage:{values:c=>c.shopConfigs.flatMap(v=>v.voltage||[]), allowed:equipment},
      shop_cabinet:{values:c=>[c.dataset.shopCabinet], allowed:family==='refrigeration'},
      shop_doors:{values:c=>[c.dataset.shopDoors], allowed:family==='refrigeration'},
      shop_door_type:{values:c=>[c.dataset.shopDoorType], allowed:family==='refrigeration'},
      shop_compressor:{values:c=>[c.dataset.shopCompressor], allowed:family==='refrigeration'}
    };
    Object.entries(specs).forEach(([name,spec]) => {
      const field=f[name],current=field.value;
      const source = name==='shop_brand' ? (searched.length ? searched : scope) : context;
      const options=[...new Set(source.flatMap(spec.values).filter(Boolean).map(String))].sort((a,b)=>a.localeCompare(b,undefined,{numeric:true}));
      while(field.options.length>1) field.remove(1);
      if(spec.allowed) options.forEach(value=>{
        const option=document.createElement('option');option.value=value;
        option.textContent=name==='shop_phase'?(value==='1'?'Single phase':value==='3'?'Three phase':value+' phase'):name==='shop_voltage'?value+' V':name==='shop_doors'?value+(value==='1'?' door':' doors'):value;
        field.append(option);
      });
      field.value=spec.allowed&&options.includes(current)?current:'';
      field.closest('.shop-browse-field').hidden=!spec.allowed||options.length===0;
    });
    const setGroup=(group,shown)=>{this.querySelector('[data-filter-group="'+group+'"]').hidden=!shown;};
    setGroup('coffee',family==='coffee');
    setGroup('warewashing',family==='warewashing'&&context.some(c=>c.dataset.shopStyle||c.dataset.shopSanitizing));
    setGroup('refrigeration',family==='refrigeration'&&context.some(c=>c.dataset.shopDoors||c.dataset.shopDoorType||c.dataset.shopCompressor||c.dataset.shopCabinet));
    setGroup('electrical',equipment&&context.some(c=>c.shopConfigs.some(v=>v.phase||(v.voltage||[]).length)));
    const hasDimensions=equipment&&context.some(c=>c.dataset.shopWidth||c.dataset.shopDepth||c.dataset.shopHeight);
    setGroup('dimensions',hasDimensions);
    if(!hasDimensions) ['shop_width','shop_depth','shop_height'].forEach(name=>{f[name].value='';});
    this.querySelector('[data-door-clearance-note]').hidden=family!=='warewashing';
    const hint=this.querySelector('[data-filter-context]');
    hint.hidden=equipment;
    hint.textContent=family==='supplies'?'Brand and price filters apply to these supplies.':'Choose a category or narrow your search to see equipment-specific filters.';
    this.querySelectorAll('[data-category-count]').forEach(el=>{
      el.textContent=String(this.cards.filter(c=>this.matchesCategory(c,el.dataset.categoryCount)).length);
    });
  }
  readURL() {
    const params = new URL(location.href).searchParams;
    this.category = params.get('shop_category') || '';
    if (![...this.querySelectorAll('button[data-shop-category]')].some(b => b.dataset.shopCategory === this.category)) this.category = '';
    this.populate();
    this.names.forEach(name => { this.form.elements[name].value = params.get(name) || (name === 'shop_sort' ? 'featured' : ''); });
  }
  apply(updateURL = true) {
    this.populate();
    const f = this.form.elements, value = name => f[name].value;
    const query = value('shop_q').trim().toLowerCase();
    const min = value('shop_min') === '' ? 0 : Number(value('shop_min')) * 100;
    const max = value('shop_max') === '' ? Infinity : Number(value('shop_max')) * 100;
    const sort = value('shop_sort');
    const matchingPrices = new Map();
    this.cards.forEach(c => matchingPrices.set(c,c.shopConfigs.filter(v =>
      Number(v.price) >= min && Number(v.price) <= max
      && (!value('shop_phase') || String(v.phase) === value('shop_phase'))
      && (!value('shop_voltage') || (v.voltage || []).includes(value('shop_voltage')))
    ).map(v => Number(v.price))));
    const sorted = [...this.cards].sort((a,b) => {
      const pa = Math.min(...matchingPrices.get(a)), pb = Math.min(...matchingPrices.get(b));
      if (sort === 'price-ascending') return pa - pb;
      if (sort === 'price-descending') return pb - pa;
      if (sort === 'title-ascending') return a.dataset.shopTitle.localeCompare(b.dataset.shopTitle);
      return Number(a.dataset.shopOrder) - Number(b.dataset.shopOrder);
    });
    let count = 0;
    sorted.forEach(card => {
      const matches = this.matchesCategory(card,this.category)
        && (!value('shop_brand') || card.dataset.shopBrand === value('shop_brand'))
        && (!query || card.dataset.shopTitle.toLowerCase().includes(query))
        && (!value('shop_coffee_application') || card.dataset.shopCoffeeApplication === value('shop_coffee_application'))
        && (!value('shop_coffee_drink') || card.shopCoffeeDrinks.includes(value('shop_coffee_drink')))
        && (!value('shop_coffee_water') || card.dataset.shopCoffeeWater === value('shop_coffee_water'))
        && (!value('shop_coffee_daily') || card.dataset.shopCoffeeDaily === value('shop_coffee_daily'))
        && (!value('shop_style') || card.dataset.shopStyle === value('shop_style'))
        && (!value('shop_sanitizing') || card.dataset.shopSanitizing === value('shop_sanitizing'))
        && (!value('shop_cabinet') || card.dataset.shopCabinet === value('shop_cabinet'))
        && (!value('shop_doors') || card.dataset.shopDoors === value('shop_doors'))
        && (!value('shop_door_type') || card.dataset.shopDoorType === value('shop_door_type'))
        && (!value('shop_compressor') || card.dataset.shopCompressor === value('shop_compressor'))
        && ['width','depth','height'].every(key => !value('shop_'+key) || (card.dataset['shop'+key[0].toUpperCase()+key.slice(1)] && Number(card.dataset['shop'+key[0].toUpperCase()+key.slice(1)]) <= Number(value('shop_'+key))))
        && matchingPrices.get(card).length > 0;
      card.hidden = !matches;
      if (matches) count++;
      this.list.append(card);
    });
    this.querySelector('[data-shop-count]').textContent = count + (count === 1 ? ' product' : ' products');
    const empty = this.querySelector('[data-shop-empty]');
    empty.hidden = count > 0;
    empty.textContent = this.category === 'discount-equipment' && !this.cards.some(c => this.matchesCategory(c,this.category))
      ? 'No discount, scratch & dent or refurbished units are currently listed. Check back for availability.'
      : 'No products match these filters. Try a different category, specification or price range.';
    this.querySelectorAll('button[data-shop-category]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.shopCategory === this.category)));
    this.renderChips();
    if (updateURL) {
      const url = new URL(location.href);
      const values = {shop_category:this.category,...Object.fromEntries(this.names.map(n => [n,n === 'shop_sort' && value(n) === 'featured' ? '' : value(n).trim()]))};
      Object.entries(values).forEach(([n,v]) => v ? url.searchParams.set(n,v) : url.searchParams.delete(n));
      history.replaceState(null,'',url);
    }
  }
  renderChips() {
    const container = this.querySelector('[data-active-filters]'); container.replaceChildren();
    const labels = {shop_q:'Search',shop_brand:'Brand',shop_min:'Min CAD',shop_max:'Max CAD',shop_style:'Style',shop_sanitizing:'Sanitizing',shop_phase:'Phase',shop_voltage:'Voltage',shop_width:'Max width (in.)',shop_depth:'Max depth (in.)',shop_height:'Max height (in.)',shop_cabinet:'Cabinet',shop_doors:'Doors',shop_door_type:'Door type',shop_compressor:'Compressor',shop_coffee_application:'Application',shop_coffee_drink:'Drink style',shop_coffee_water:'Water supply',shop_coffee_daily:'Cups per day'};
    let count = 0;
    Object.entries(labels).forEach(([name,label]) => {
      const field = this.form.elements[name]; if (!field.value) return; count++;
      const chip = document.createElement('button'); chip.type='button';
      const display = field.tagName === 'SELECT' ? field.selectedOptions[0].textContent : field.value;
      chip.textContent = label + ': ' + display + ' ×'; chip.setAttribute('aria-label','Remove '+label+' filter');
      chip.addEventListener('click',() => { field.value=''; this.apply(); }); container.append(chip);
    });
    this.querySelector('[data-filter-badge]').textContent = count ? '('+count+')' : '';
    this.querySelector('[data-shop-reset]').hidden = count === 0 && !this.category;
  }
}
if (!customElements.get('shop-browse-preview')) customElements.define('shop-browse-preview',ShopBrowsePreview);
